<template>
  <section class="bg-amber-100 pb-32 pt-14">
    <Container indent="container-tight">
      <Filter
        :terms="cmsDataEventsAndFilter.data?.terms?.data"
        @update="filterUpdate($event)"
      />
      <!-- CARDS -->
      <TransitionGroup
        tag="ul"
        name="list-filter"
        mode="out-in"
        class="relative mt-8 grid sm:mt-14"
      >
        <li
          v-for="card in filteredEvents"
          :key="card.id"
          class="inset-0 transition-all"
          :class="`${card.color_theme?.value || 'blue'}-el`"
        >
          <EventCardAccordion
            v-if="card.event_card_layout.value === 'as_accordion'"
            :card="card"
            class="mb-6"
          />
          <EventCard v-else :card="card" class="mb-6" />
        </li>
      </TransitionGroup>

      <!-- NO EVENTS FOUND -->
      <div v-if="filteredEvents.length === 0" class="mb-14 w-full">
        <p class="text-center">
          Es wurden leider keine Veranstaltungen gefunden.
        </p>
      </div>
    </Container>
  </section>
</template>

<script setup>
import { store } from '/store.js'
const cmsDataEventsAndFilter = ref(null)

const isSimpleLanguage = store?.isSimpleLanguage ?? false
const site = isSimpleLanguage ? 'de-plain' : 'default'

// Fetch all events and Filters
cmsDataEventsAndFilter.value = await useAsyncGql({
  operation: 'EventsAndCategories',
  variables: { site: site },
})

const events = ref(cmsDataEventsAndFilter.value.data.entries.events)
const filteredEvents = ref(cmsDataEventsAndFilter.value.data.entries.events)
const params = useUrlSearchParams('history')

function filterUpdate(categories) {
  filteredEvents.value = useFilters(categories, events.value)
}

onMounted(() => {
  if (params.categories) {
    filterUpdate([params.categories])
  }
})
</script>
